import { OAuthCredential } from 'mbs-ui-shared@models';
import { TokenData } from 'mbs-ui-shared@models/auth-models';

export default function getAdaptedCredentials(tokenData: TokenData): OAuthCredential {
  // TODO: Remove it asap Gareev A.
  const credentials = new OAuthCredential();
  credentials.token = tokenData?.token;
  credentials.access_token = tokenData.accessToken;
  credentials.refresh_token = tokenData.refreshToken;
  credentials.token_type = 'Bearer';
  credentials.revokedSessions = tokenData.revokedSessions;
  return credentials;
}
